import { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { GetVehicleHaltPointViewDetails } from "./ReportApi";
import { FILE_BASE_URL } from "../../../Services/baseApiUrl";

const NAVY = "#003366";

const navyHeaderStyle = {
  backgroundColor: NAVY,
  color: "#FFFFFF",
  borderBottom: "none",
  padding: "14px 20px",
};

const ModalCloseIcon = ({ onClick, light }) => (
  <i
    className="fa-solid fa-xmark close-container"
    onClick={onClick}
    style={light ? { color: "#FFFFFF", cursor: "pointer" } : undefined}
  />
);

export const ClearedPointDetailModal = ({ show, point, onClose, circleId, vehicleId }) => {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show || !point) {
      setDetails(null);
      return;
    }

    const fetchDetails = async () => {
      try {
        setLoading(true);
        const params = {
          circleId: point.circleId || circleId || undefined,
          vehicleId: point.vehicleId || vehicleId || undefined,
          stoppageId: point.stoppageId || point.id || undefined,
        };
        const res = await GetVehicleHaltPointViewDetails(params);
        let data = res?.data;
        if (Array.isArray(data)) {
          // If array, find matching stoppage or take first item
          const match =
            data.find(
              (item) =>
                String(item.stoppageId || item.id) ===
                String(point.stoppageId || point.id)
            ) || data[0];
          setDetails(match || point);
        } else if (data?.data) {
          const item = Array.isArray(data.data) ? data.data[0] : data.data;
          setDetails(item || point);
        } else if (data) {
          setDetails(data);
        } else {
          setDetails(point);
        }
      } catch (error) {
        console.error("Error fetching halt point view details:", error);
        setDetails(point);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [show, point, circleId, vehicleId]);

  const displayData = details || point;
  const imageSource = displayData?.image || displayData?.imageUrl || displayData?.filePath;
  const fullImageUrl =
    imageSource && !imageSource.startsWith("http") && !imageSource.startsWith("data:")
      ? `${FILE_BASE_URL}${imageSource}`
      : imageSource;

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header style={navyHeaderStyle}>
        <Modal.Title className="fw-bold text-white fs-5 mb-0">
          Cleared Point Details
        </Modal.Title>
        <ModalCloseIcon onClick={onClose} light />
      </Modal.Header>
      <Modal.Body className="px-4 py-4">
        {loading ? (
          <div className="d-flex justify-content-center align-items-center py-5">
            <Spinner animation="border" role="status" style={{ color: NAVY }}>
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : displayData ? (
          <div className="d-flex flex-column gap-3">
            <div>
              <span className="fw-semibold">Vehicle Number</span>
              <span className="mx-2">:</span>
              <span>
                {displayData.vehicleNo ||
                  displayData.vehicleNumber ||
                  point?.vehicleNo ||
                  point?.vehicleNumber ||
                  "—"}
              </span>
            </div>
            <div>
              <span className="fw-semibold">Halt Point</span>
              <span className="mx-2">:</span>
              <span>{displayData.haltPoint || point?.haltPoint || "—"}</span>
            </div>
            <div>
              <span className="fw-semibold">Latitude</span>
              <span className="mx-2">:</span>
              <span>
                {displayData.latitude ||
                  displayData.actualLatitude ||
                  point?.latitude ||
                  "—"}
              </span>
            </div>
            <div>
              <span className="fw-semibold">Longitude</span>
              <span className="mx-2">:</span>
              <span>
                {displayData.longitude ||
                  displayData.actualLongitude ||
                  point?.longitude ||
                  "—"}
              </span>
            </div>
            <div>
              <div className="fw-semibold mb-2">Image</div>
              <div
                className="border rounded d-flex align-items-center justify-content-center bg-light overflow-hidden"
                style={{ minHeight: 180 }}
              >
                {fullImageUrl ? (
                  <img
                    src={fullImageUrl}
                    alt={displayData.haltPoint || "Halt point"}
                    style={{
                      maxWidth: "100%",
                      maxHeight: 240,
                      objectFit: "contain",
                    }}
                  />
                ) : (
                  <span className="text-muted">No image available</span>
                )}
              </div>
            </div>
          </div>
        ) : null}
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0 px-4 pb-4 d-flex justify-content-end">
        <button
          type="button"
          className="btn btn-outline-secondary px-4"
          onClick={onClose}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};
